import React from 'react'
import UploadStore from '../../stores/upload-store'
import Config from '../../config'
import createReactClass from 'create-react-class'
require ('../../utils/upload-event-handlers');



function getUploadData() {
	return UploadStore.getData();
}

var PageContainer = createReactClass({

  getInitialState: function () {
  	return {uploadData: getUploadData()};
  },
  componentWillMount:function() {
	UploadStore.addChangeListener(this._onChange);
  },
  componentWillUnmount: function() {
    UploadStore.removeChangeListener(this._onChange);
  },

  _onChange: function () {
      this.setState({uploadData: getUploadData()});
  },
  getVendorName: function () {
    return Config.VendorVariables[sessionStorage.getItem('vendor')].logoClassName;
  },
  getCustomerServiceLink: function () {
    var vendor = sessionStorage.getItem('vendor');
    return Config.VendorVariables[vendor].customerServiceUrl
  },
  getDisclaimerLink: function () {
    var vendor = sessionStorage.getItem('vendor');
    return Config.VendorVariables[vendor].disclaimerUrl
  },
  getPrivacyLink: function () {
    var vendor = sessionStorage.getItem('vendor');
    return Config.VendorVariables[vendor].privacyUrl
  },
  getSiteLink: function () {
    var vendor = sessionStorage.getItem('vendor');
    return Config.VendorVariables[vendor].siteUrl
  },
  getCopyrightName: function () {
    var vendor = sessionStorage.getItem('vendor');
    return Config.VendorVariables[vendor].copyrightName;
  },
  render: function() {
    return (
      <div>
          <div className="page-header">
            <div className="page-header__inner">
              <a href={this.getSiteLink()} className="page-header__inner__siteLink">
                <i className={"icon logo " + this.getVendorName() + " small"}></i>
              </a>
                <a href={this.getCustomerServiceLink()}  rel="noreferrer" className="page-header__inner__customerServiceLink" target="_blank" >
                  {_("Customer service")}
                </a>
                <div style={{clear: 'both'}}></div>
              </div>
          </div>
          <div className="page-container">
            {this.props.children}
            {this.state.uploadData.browserOffline?
            <div className="page-container__offline-alert">
            	{_("Your device has lost internet connection")}
            </div> : <div></div> }
          </div>
          <div className="page-footer">
              <p className="page-footer__copyright">{this.getCopyrightName()} © {new Date().getFullYear()}</p>
              <a href={this.getDisclaimerLink()} rel="noreferrer" target="_blank" className="page-footer__disclaimerLink">{_("Disclaimer")}</a>
              <a href={this.getPrivacyLink()} rel="noreferrer" target="_blank" className="page-footer__privacyLink">{_("Privacy")}</a>
              <div style={{clear: 'both'}}></div>
              <div style={{color: 'white'}}>SessionId: {sessionStorage.getItem('sessionId')}</div>
          </div>
    </div>
    );
  }
});

export default PageContainer;
